import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export interface IMetricProperty {
    [key: string]: any;
  }
  
  export const useKissMetrics = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const uuid = searchParams.get("UUID");
  
    useEffect(() => {

      (window as any)._kmq.push(["identify", uuid]);

      const currentUrl = location.pathname;
      let props: IMetricProperty[] = [];
  
      //append standard metric data
      props.push({ "PagePath": currentUrl });
      if (uuid){
        props.push({ "UUID": uuid });
      }
  
      // convert list of metric properties to an object literal
      let propObj = {};
      props.forEach((prop) => {
        propObj = { ...propObj, ...prop };
      });
  
      if (window === null) {
        throw new Error("KissMetrics requires a valid Window object.");
      }
  
      if ((window as any)._kmq === null) {
        throw new Error("KissMetrics has not been initialized.");
      }
  
      (window as any)._kmq.push(["record", "Signup Form Pageview", propObj]);
    }, [location, uuid]);
  };